import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { ExceptionDay } from "PFTypes/booking/booking_config";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CalendarForm } from "../../calendars.types";
import { CustomDayOff } from "./components/custom_day_off/custom_day_off";
import { WeekDays } from "./components/week_days";
import css from "./dates.module.scss";

interface DatesProps {
  edit?: boolean;
  handleDeleteExceptionDay?: (exceptionDay: ExceptionDay) => void;
  submitForm?: () => void;
}

export const Dates = ({ edit, handleDeleteExceptionDay, submitForm }: DatesProps) => {
  const { t } = useTranslation("bookingModule");
  const { control } = useFormContext<CalendarForm>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "exceptionDays"
  });

  const handleRemove = (index: number, exceptionDay) => {
    if (handleDeleteExceptionDay && exceptionDay) {
      handleDeleteExceptionDay(exceptionDay);
    }
    remove(index);
  };

  const handleAddException = (event) => {
    event.preventDefault();
    append({
      name: t("config.calendars.exceptionDays.newExceptionDayLabel"),
      date: null,
      startTime: "00:00",
      endTime: "23:59",
      kind: "holiday",
      workingMinutes: 0
    });
  };
  return (
    <>
      <div className={css.container}>
        <section>
          <Typography variant="h4" className={css.title}>
            {t("config.calendars.workingDays.title")}
          </Typography>
          <Typography variant="bodyRegular">{t("config.calendars.workingDays.description")}</Typography>
          <WeekDays />
        </section>
        <section className={css.exceptionSection}>
          <Typography variant="h4" className={css.title}>
            {t("config.calendars.exceptionDays.title")}
          </Typography>
          <Typography variant="bodyRegular">{t("config.calendars.exceptionDays.description")}</Typography>
          {fields.map((field, index) => (
            <CustomDayOff key={field.id} index={index} onRemove={handleRemove} />
          ))}
          <div className={css.actionsWrapper}>
            <Button kind="tertiary" onClick={handleAddException}>
              + {t("config.calendars.addExceptionDay")}
            </Button>
          </div>
        </section>
      </div>
      <div className={css.actionsWrapper}>
        <Button kind="tertiary" onClick={() => submitForm?.()}>
          {t(edit ? "config.calendars.newCalendar.update" : "config.calendars.newCalendar.submit")}
        </Button>
      </div>
    </>
  );
};
